import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
  actionPath?: string;
  actionLabel?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "left",
  actionPath,
  actionLabel,
}: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div
      className={`flex flex-col gap-4 ${
        isCenter
          ? "items-center text-center"
          : "sm:flex-row sm:items-end sm:justify-between"
      }`}
    >
      <div className={isCenter ? "max-w-2xl" : "max-w-2xl"}>
        {eyebrow && (
          <span className="inline-flex items-center gap-1.5 text-xs font-medium tracking-[0.18em] text-primary-600 uppercase">
            <span className="w-4 h-px bg-primary-400" />
            {eyebrow}
          </span>
        )}
        <h2 className="mt-3 font-heading font-bold text-2xl md:text-4xl text-foreground-950">
          {title}
        </h2>
        {desc && (
          <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-600">{desc}</p>
        )}
      </div>
      {actionPath && actionLabel && (
        <Link
          to={actionPath}
          className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 whitespace-nowrap"
        >
          {actionLabel}
          <i className="ri-arrow-right-line" />
        </Link>
      )}
    </div>
  );
}